import React, { forwardRef, useImperativeHandle } from 'react';
import { Icon, Radio } from '@beehive/components';

export enum DemandTypeEnum {
  CD = 'channel_group',
  MC = 'market_group',
}

export const DemandTypeOptions = [
  {
    name: '渠道发行中心需求',
    value: DemandTypeEnum.CD,
    icon: 'workbench-o',
  },
  {
    name: '市场中心需求',
    value: DemandTypeEnum.MC,
    icon: 'workbench-o',
  },
];

type Props = {
  value: DemandTypeEnum;
  prefixClx: string;
  [key: string]: any;
};

const DemandType = forwardRef((props: Props, ref: any) => {
  const {
    prefixClx = 'demand-type-radio-group',
    value,
    onChange,
    ...reset
  } = props;

  useImperativeHandle(ref, () => ({
    getValue() {
      return value;
    },
  }));

  const handeChange = (evt: any) => {
    const v = evt.target.value;
    if (onChange) {
      onChange(v);
    }
  };

  return (
    <Radio.Group
      mode="tag"
      clasName={prefixClx}
      options={DemandTypeOptions.map((item) => {
        return {
          name: (
            <>
              <Icon name={item.icon} size={20} />
              <span>{item.name}</span>
            </>
          ),
          value: item.value,
        };
      })}
      {...reset}
      value={value}
      onChange={handeChange}
    />
  );
});

export default DemandType;
